import { endpoints } from '../api/endpoints'
import { API } from './comunApi'

export const hospitalsApi = {
    deleteHospitals: async id => {
        return await API.delete(
            endpoints.DELETE_HOSPITALS(id)
        )
    },
    newHospitals: params => (
        API.post(
            endpoints.NEW_HOSPITALS,
            params
        )
    ),
    getHospitalById: async id => {
        return await API.get(
            endpoints.GET_HOSPITALS_BY_ID(id)
        )
    },
    updateHospitals: params => (
        API.put(
            endpoints.UPDATE_HOSPITALS,
            params
        )
    ),

    getAllHospitalsAndZones: async () => {
        return await API.get(
            endpoints.GET_ALL_HOSPITALS
        )
    },

    getAllHospitalsBySearch: async (search) => {
        return await API.get(
            endpoints.GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED(0, search, 0)
        )
    },

    //Devuleve todos los hospitales de una zona y sus contactos
    getAllHospitalsInAnAreaAndTheirContacts: async () => {
        return await API.get(
            endpoints.GET_ALL_HOSPITALS_AND_THEIR_CONTACTS_BY_USER_ZONE
        )
    },
}